export const IS_CRITICAL = [
  { label: 'Да', value: 'true' },
  { label: 'Нет', value: 'false' },
];
